import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { IconInfoBlue, IconErrorRed, IconBell } from 'icons'
import styles from './Alert.scss'

class Alert extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isHidden: false,
    }
  }

  handleClose = () => {
    this.setState({ isHidden: true })
  }

  render() {
    const { type, children, showCloseButton } = this.props
    const classes = {
      [styles.hide]: this.state.isHidden,
      [styles.info]: type === 'info',
      [styles.error]: type === 'error',
      [styles.message]: type === 'message',
    }

    const alertIcon = (alertType) => {
      switch (alertType) {
        case 'info':
          return <IconInfoBlue height="20" width="20" />
        case 'error':
          return <IconErrorRed height="20" width="20" />
        case 'message':
          return <IconBell height="20" width="20" />
        default:
          return <IconInfoBlue height="20" width="20" />
      }
    }

    return (
      <div className={classnames(styles.base, classes)}>
        <div className={styles.noteIcon}>
          {alertIcon(type)}
        </div>
        <div className={styles.noteText}>
          {children}
        </div>
        {showCloseButton && <div className={styles.closebtn} onClick={this.handleClose}>&times;</div>}
      </div>
    )
  }
}

Alert.propTypes = {
  type: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]),
  showCloseButton: PropTypes.bool,
}

Alert.defaultProps = {
  type: 'info',
  showCloseButton: true,
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js